import retryRequest from './retryRequest';

const waiting: Array<() => void> = [];
let active = 0;

// Shared by originals and thumbnails, so preparation concurrency cannot flood HTTP.
function scheduleRequest<T>(request: () => Promise<T>, signal: AbortSignal): Promise<T> {
    return new Promise((resolve, reject) => {
        const abort = () => {
            const index = waiting.indexOf(start);
            if (index >= 0) waiting.splice(index, 1);
            reject(new DOMException('Upload cancelled', 'AbortError'));
        };
        const start = () => {
            signal.removeEventListener('abort', abort);
            if (signal.aborted) { abort(); return; }
            active++;
            Promise.resolve().then(request).then(resolve, reject).finally(() => {
                active--;
                waiting.shift()?.();
            });
        };
        if (signal.aborted) { abort(); return; }
        if (active < 6) start();
        else {
            waiting.push(start);
            signal.addEventListener('abort', abort, { once: true });
        }
    });
}

// A retry re-enters the queue; backoff does not occupy a connection slot.
export default function uploadRequest<T>(request: () => Promise<T>, signal: AbortSignal): Promise<T> {
    return retryRequest(() => scheduleRequest(request, signal), signal);
}
